import React from "react";
import "./HomeFlags.css"
const HomeFlagsHead = () => {
  return (
    <div className="HomeFlagHead">
      <h2>Verification Done in Just 3 Days</h2>
      <div className="flagUnderline"></div>
    </div>
  );
};

export default HomeFlagsHead;
